import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appHelper from '../../../helpers/appHelper';
import CharacterSpeak from './ProtoypeCharacterSpeak';
import LearnerSpeak from './PrototypeLearnerSpeak';
import ConversationChoice from './PrototypeConversationChoice';

class PrototypeConversation extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {

        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    componentDidUpdate() {

    }

    render() {
        return (
            <div className={`prototype-objects`}>
                <CharacterSpeak/>
                <LearnerSpeak/>
                <ConversationChoice/>
            </div>
        );
    }
}

PrototypeConversation.propTypes = {
    locale: PropTypes.object,
};

PrototypeConversation.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, {}), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrototypeConversation);



/** WEBPACK FOOTER **
 ** ./src/components/objects/prototypeObjects/PrototypeConversation.js
 **/